import {JsonObject, JsonProperty} from 'json2typescript';
import {Condition} from './Condition';

@JsonObject('QuestionCondition')
export class QuestionCondition implements Condition {

    @JsonProperty('question_no',Number)
    private question_no  = 0;

    @JsonProperty('choice_no',Number)
    private choice_no = 0;

    @JsonProperty('not',Boolean)
    private not = false;

    @JsonProperty('type',String)
    type = '';

    @JsonProperty('conditionClass',String)
    conditionClass = '';

    /*getConditionClass():string {
        return this.conditionClass;
    }

    setConditionClass(conditionClass:string):void {
        this.conditionClass = conditionClass;
    }

    getType():string {
        return this.type;
    }

    setType(type:string):void {
        this.type = type;
    }*/



    public QuestionCondition() { this.conditionClass = 'simple';}


    getQuestionNo():number {
        return this.question_no;
    }

    setQuestionNo(value: number) {
        this.question_no = value;
    }

    getChoiceNo(): number {
        return this.choice_no;
    }

    setChoiceNo(value: number) {
        this.choice_no = value;
    }

    isNot(): boolean {
        return this.not;
    }

    setNot(value: boolean) {
        this.not = value;
    }
}
